import toast from "react-hot-toast"
import { userData } from "../store/actions"
import {
  initializeGestockSubscriptionPayment,
  upgradeGestockSubscription,
} from "../api/auth/subscription"

type UpgradeParams = {
  planKey: string
  billingCycle?: "monthly" | "yearly"
  currentPlan?: string
  currentBillingCycle?: string | null
  user?: any
  dispatch: any
  onClose?: () => void
}

export async function runSubscriptionUpgrade({
  planKey,
  billingCycle = "monthly",
  currentPlan = "FREE",
  currentBillingCycle,
  user,
  dispatch,
  onClose,
}: UpgradeParams) {
  const targetPlan = String(planKey || "").toUpperCase()
  const activePlan = String(currentPlan || "FREE").toUpperCase()
  const activeBillingCycle = String(currentBillingCycle || "monthly").toLowerCase()
  const targetBillingCycle = String(billingCycle || "monthly").toLowerCase() === "yearly" ? "yearly" : "monthly"

  if (!targetPlan) return

  if (targetPlan === activePlan && targetBillingCycle === activeBillingCycle) {
    toast("Ce plan est déjà actif")
    return
  }

  try {
    if (targetPlan === "FREE") {
      await upgradeGestockSubscription(targetPlan, targetBillingCycle)
      dispatch(userData())
      toast.success("Abonnement mis à jour")
      onClose?.()
      return
    }

    const digitsPhone = String(user?.phone || "")
      .replace(/[^\d]/g, "")
      .trim()
    const safeLocal = digitsPhone || `${Date.now()}`
    const email =
      String(user?.email || "").trim() || `gestock-${safeLocal}@loven-soft.com`
    const phone = String(user?.phone || "").trim()

    const payment = await initializeGestockSubscriptionPayment({
      planKey: targetPlan,
      billingCycle: targetBillingCycle,
      email,
      phone,
      provider: "mobile_money",
    })

    const redirectUrl =
      payment?.authorization_url ||
      payment?.data?.authorization_url ||
      payment?.paystack_init?.data?.authorization_url

    if (!redirectUrl) {
      toast.error("Paiement initialisé, mais lien de paiement indisponible")
      return
    }

    // window.location.href = redirectUrl
    window.open(redirectUrl, '_blank')
  } catch (e: any) {
    toast.error(e?.message || "Impossible de mettre à niveau cet abonnement")
  }
}
